import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Layout from '~/src/layout/_layout';
import * as base from '~/src/helpers/basePageFunc';
import { Look } from '~/src/layout/look';

const LookPage = (props) => {
    const { hostname } = props;
    const currentCity = useSelector(state => state.city.currentCity);
    const link = `https://${currentCity?.domain}.dom.ru/domru-tv/look`;

    return (
        <Layout
            title={'Онлайн кинотеатр от Дом.ru - смотрите в HD фильмы, сериалы и ТВ передачи без рекламы в хорошем качестве'}
            description={'Онлайн кинотеатр от Дом.ru - это новинки кино, популярные сериалы и ТВ программы в HD и Full HD качестве. Синхронизация с мобильными устройствами и Smart-TV. Подробнее на сайте.'}
            hostname={hostname}
            withMenu={true}
            withHeader={true}
            withChat={true}
            withFooter={true}
            relCanonical={link}
        >
            <Look />
        </Layout>
    );
};

LookPage.getInitialProps = async(ctx) => {
    const { hostname } = await base.initialProps(ctx);
    return { hostname };
};

LookPage.propTypes = {
    currentCity: PropTypes.object,
    hostname: PropTypes.string,
};

LookPage.defaultProps = {
    currentCity: {},
    hostname: '',
};

export default LookPage;
